var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"widget-preview-grid"},_vm._l((_vm.posts),function(post,index){return _c('div',{key:index,staticClass:"widget-item"},[_c('widget-preview-item',{attrs:{"post":post,"snsType":_vm.snsType}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }